import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fef4ac3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "safecheckInfo" }
const _hoisted_2 = {
  key: 0,
  class: "top-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "检查类型：")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "检查单类型：")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "编号：")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "检查项：")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "限定整改时间：")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "项目名称：")
], -1))
const _hoisted_9 = { class: "checkUser" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "检查人：")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "整改责任人：")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "整改内容：")
], -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "整改前照片：")
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  class: "pictures",
  style: {"width":"100%"}
}
const _hoisted_18 = ["src", "onClick"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "整改后照片：")
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { key: 3 }
const _hoisted_23 = {
  class: "pictures",
  style: {"width":"100%"}
}
const _hoisted_24 = ["src", "onClick"]
const _hoisted_25 = { key: 4 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "审批人：")
], -1))
const _hoisted_27 = {
  key: 1,
  class: "formSubmit",
  style: {"margin":"10px auto","width":"92%","background-color":"white"}
}
const _hoisted_28 = {
  key: 0,
  class: "picListAfter"
}
const _hoisted_29 = {
  key: 1,
  class: "jiange"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiange" }, null, -1))
const _hoisted_31 = {
  key: 4,
  class: "button"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_33 = { style: {"height":"100%","display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_34 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_selectperson = _resolveComponent("selectperson")!
  const _component_approveSelectshow = _resolveComponent("approveSelectshow")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["title", "onClickLeft"]),
    (_ctx.infodata)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.infodata.checkType === "1"
                ? "监督检查"
                : _ctx.infodata.checkType === "2"
                ? "企业检查"
                : "项目检查"), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["checktype", {
              _wrain: _ctx.infodata.billType === '2',
              _danger: _ctx.infodata.billType === '3',
            }])
              }, _toDisplayString(_ctx.infodata.billType === "1"
                ? "检查记录单"
                : _ctx.infodata.billType === "2"
                ? "隐患整改单"
                : "停工整改单"), 3)
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.infodata.billNo), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.infodata.deptName) + " " + _toDisplayString(_ctx.infodata.itemName) + " " + _toDisplayString(_ctx.infodata.areaName), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_7,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.infodata.limitDate), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_8,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.infodata.projectName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.checkUserList, (li, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(li.checkUserName) + "(" + _toDisplayString(li.idNo) + ") ", 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_11,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.infodata.directorName), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_12,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.infodata.speechContent), 1)
            ])
          ]),
          (_ctx.infodata.picListBefore != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.infodata.picListBefore != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.picListBefore, (li, i) => {
                    return (_openBlock(), _createElementBlock("img", {
                      src: li.url,
                      key: i,
                      onClick: ($event: any) => (_ctx.previewimgfun(li.url))
                    }, null, 8, _hoisted_18))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.infodata.status !== '0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
            : _createCommentVNode("", true),
          (_ctx.infodata.status !== '0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.picListAfter, (li, i) => {
                    return (_openBlock(), _createElementBlock("img", {
                      src: li.url,
                      key: i,
                      onClick: ($event: any) => (_ctx.previewimgfun(li.url))
                    }, null, 8, _hoisted_24))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.infodata.status === '2')
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.infodata.currentName), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.canRec === 'Y' || _ctx.canApp === 'Y')
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
            default: _withCtx(() => [
              (_ctx.canRec === 'Y')
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_van_field, {
                      rules: [{ required: true, message: '请选择整改后照片' }],
                      required: "",
                      label: "整改后照片："
                    }, {
                      input: _withCtx(() => [
                        _createVNode(_component_van_uploader, {
                          modelValue: _ctx.uploaderAfter,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploaderAfter) = $event)),
                          "after-read": _ctx.afterRead,
                          multiple: _ctx.$isIOS()
                        }, null, 8, ["modelValue", "after-read", "multiple"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.canRec === 'Y')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                : _createCommentVNode("", true),
              (_ctx.canRec === 'Y')
                ? (_openBlock(), _createBlock(_component_selectperson, {
                    key: 2,
                    onSelected: _ctx.checkUserNameselected
                  }, null, 8, ["onSelected"]))
                : _createCommentVNode("", true),
              (_ctx.canApp === 'Y')
                ? (_openBlock(), _createBlock(_component_approveSelectshow, {
                    key: 3,
                    submitform: _ctx.subform
                  }, null, 8, ["submitform"]))
                : _createCommentVNode("", true),
              _hoisted_30,
              (_ctx.canRec === 'Y' || _ctx.canApp === 'Y')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createVNode(_component_van_button, {
                      block: "",
                      "native-type": "submit"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_overlay, {
      show: _ctx.show,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("img", {
            src: _ctx.previewimg,
            style: {"width":"100%"}
          }, null, 8, _hoisted_34)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}